<template>
    <DataTable :loading="!header" :value="dataArray" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table"
        :rowClass="hideRow">
        <Column>
            <template #header="">
                <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" />
            </template>
            <template #body="slotProps">
                <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" />
            </template>
        </Column>
        <Column field="Status" :header="$t('status')" key="Status">
            <template #body="slotProps">
                <InputText name="Status" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('status')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
        <Column field="CompanyId" :header="$t('company')" key="CompanyId">
            <template #body="slotProps">
                <CustomSelect v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/company_code_id'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); companychange(slotProps, $event)"
                    :disabled="!canEdit || slotProps.data.Status != this.$APPROVAL_STATUS.NEW" :params="{}" />
            </template>
        </Column>
        <Column field="DepartmentId" :header="$t('department')" key="DepartmentId">
            <template #body="slotProps">
                <CustomSelect v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/department_byidcoy'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); deptchange(slotProps, $event)"
                    :disabled="!canEdit || slotProps.data.Status != this.$APPROVAL_STATUS.NEW"
                    :params="{ companyId: slotProps.data.CompanyId }" />
            </template>
        </Column>
    </DataTable>
</template>
<script>
export default {
    props: {
        dataArray: {
            type: Array,
            default: []
        },
        dataModel: {
            type: Object,
            default: []
        },
        mode: {
            type: String,
            default: ""
        },
        header: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
        }
    },
    methods: {
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.dataModel;
            newDetail.mode = this.$FORM_MODE_CREATE;
            newDetail.Status = this.$APPROVAL_STATUS.NEW;
            newDetail.VendorId = null;


            var det = { ...newDetail };


            this.dataArray.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.dataArray[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.dataArray.splice(this.dataArray.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.dataArray && this.dataArray.length > 0) {
                let m = this.dataArray[index].mode;
                if (m == this.$FORM_MODE_UNCHANGED) {
                    this.dataArray[index].mode = this.$FORM_MODE_EDIT;

                }
            }
        },
        companychange(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].CompanyId = e == null ? "" : e.id;
            }
        },
        deptchange(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].DepartmentId = e == null ? "" : e.id;
            }
        }
    },
    computed: {
        canEdit() {
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        }
    }
}
</script>